import { render, staticRenderFns } from "./acquiresDetails.vue?vue&type=template&id=4ec1f57a"
import script from "./acquiresDetails.vue?vue&type=script&lang=js"
export * from "./acquiresDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports